import React, { useEffect, useState } from 'react';
import { NativeBaseProvider, useMediaQuery, } from 'native-base';
import { View, Text, StyleSheet, TouchableOpacity, Linking, StatusBar, BackHandler, Platform } from 'react-native';
import Btn from "../components/btn"
import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import INPU from '../components/input';

import { useDispatch, useSelector } from 'react-redux';
import AwesomeAlert from 'react-native-awesome-alerts';
import { logOut, walletcharge } from '../store/action/userLogin';









const WalletCode = (props) => {
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();



    const [Price, setPrice] = useState();
    const [Wallet, setWallet] = useState(false)
    const [loading, setloading] = useState(false);
    const [error, seterror] = useState("")






    const GETWAlletHandler = async () => {
        try {
            setloading(true)
            const res = await dispatch(walletcharge(tokens, Price))
            // console.log(res.data);
            if (res.data.status == "success") {
                setWallet(true)
                seterror("کد معرف تایید شد")
            } else {
                seterror(res.data.message)
                setWallet(true)
            }
            // setWallet(res.data.wallet)
            setloading(false)
        } catch (err) {
            console.log(err);
        }
    };







    function handleBackButtonClick() {

        props.navigation.goBack()
        return true;
    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);
   




    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });

    return (
        <NativeBaseProvider>


            <View style={{
        width: isSmallScreen ? "100%" : 500,
        height: "100%",
        backgroundColor: Colors.background,
        position:Platform.OS=="web"?"fixed":"relative"
    }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.menu}   >
                        <Ionicons  name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.goBack()} style={styles.textheader1}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            بازگشت
                        </Text>
                    </TouchableOpacity>
                    <View style={styles.textheader}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 17, color: Colors.background, padding: "5%" }}>
                            پرداخت
                        </Text>
                    </View>

                </View>











              
               

                

                 

                    <INPU
                        label="کد معرف"
                        styleview={{ marginTop: "50%", }}
                        stylelabel={{ width: "15%" }}

                        value={Price}
                        onChangeText={(text) => setPrice(text)}
                        keyboardType="default"


                    />







                



                    <Btn
                        label=" تایید و ادامه "
                        style={{ marginLeft: "5%", marginTop: "40%", height: 55 }}
                        textStyle={{ bottom: 10 }}
                        loading={loading}
                        colorspin={Colors.background}
                        sizespin={25}
                        onPress={() => {
                            GETWAlletHandler()
                            // props.navigation.navigate("wallet")
                        }}
                    />


                









                <AwesomeAlert
                    show={Wallet}
                    showProgress={false}
                    title={error == "کد معرف تایید شد" ? "موفق" : "هشدار!"}
                    message={error}
                    closeOnTouchOutside={false}
                    closeOnHardwareBackPress={false}
                    // showCancelButton={true}
                    showConfirmButton={true}
                    // cancelText="باشه"
                    confirmText="باشه"
                    confirmButtonColor={Colors.success}
                    // onCancelPressed={() => {
                    //   setShow(false);
                    // }}
                    onConfirmPressed={() => {
                        if (error == "کد معرف تایید شد") {
                            props.navigation.navigate("home")
                            setWallet(false);

                        } else {

                            setWallet(false);
                           

                        }


                        //props.navigation.navigate("home")
                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: error == "کد معرف تایید شد" ? Colors.success : Colors.primarydark }}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                />



            

            </View>

        </NativeBaseProvider>
    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position:Platform.OS=="web"?"fixed":"relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS=="web"?60: 80,
        backgroundColor: Colors.primary,
    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top:Platform.OS=="web"?"15%": "35%"
    },
    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS=="web"?"15%":"35%",

    },
  
    textheader1: {
        backgroundColor: Colors.primary,
        width: 70,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS=="web"?"15%":"35%"
    },


    textclose: {
        fontFamily: "Montserrat",
        fontSize: 14,
        color: Colors.background
    },
    farsitop: {
        width: "92%",
        height: 40,
        left: 20,
        top: "8%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    farsitop1: {
        width: "92%",
        height: 40,
        left: 20,
        top: "15%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    farsitop2: {
        width: "92%",
        height: 60,
        left: 20,
        marginTop: 55,
        alignItems: "center",
        justifyContent: "center"
    },
    texttop: {
        fontFamily: "MontserratBold",
        fontSize: 15,
        color: Colors.black,
    },
    filter: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 60,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        position: "absolute",
        right: "0%",
        top: "22%"
    },


})




export default WalletCode